import { Component, Inject } from '@angular/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { RegistrationStage, A2PRegistrationService } from '@galaxy/sms';
import { map, Observable } from 'rxjs';
import {
  ACCOUNT_GROUP_ID_TOKEN,
  CONVERSATION_GOOGLE_BUSINESS_MESSAGES_AVAILABLE_TOKEN,
  CONVERSATION_SMS_ENABLED_TOKEN,
} from '../../../core/src/lib/tokens';
@Component({
  selector: 'inbox-alert-banner',
  imports: [GalaxyAlertModule, TranslateModule, AsyncPipe, NgIf],
  templateUrl: './inbox-alert-banner.component.html',
})
export class InboxAlertBannerComponent {
  readonly registrationStatus$ = this.smsRegistrationService.registrationStage$;
  readonly registrationFormRoute$ = this.accountGroupId$.pipe(
    map((id) => `/account/location/${id}/settings/inbox/sms-registration`),
  );

  protected readonly RegistrationStage = RegistrationStage;

  constructor(
    private readonly smsRegistrationService: A2PRegistrationService,
    @Inject(ACCOUNT_GROUP_ID_TOKEN) private readonly accountGroupId$: Observable<string>,
    @Inject(CONVERSATION_SMS_ENABLED_TOKEN) private smsEnabled$: Observable<boolean>,
    @Inject(CONVERSATION_GOOGLE_BUSINESS_MESSAGES_AVAILABLE_TOKEN)
    private googleBusinessMessagesAvailable$: Observable<boolean>,
  ) {}
}
